module.exports = __webpack_public_path__ + "img/acordo.5e9c9342.png";